import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateMaintenanceServiceStoreIds } from '../../api/maintenance-service.ts';
import { UpdateMaintenanceServiceStoreIdsRequest } from '../../api/requests/maintenance-service-request.ts';

export default function useUpdateMaintenanceServiceStoreIds(): UseMutationResult<
  Awaited<ReturnType<typeof updateMaintenanceServiceStoreIds>>,
  Error,
  UpdateMaintenanceServiceStoreIdsRequest
> {
  return useMutation({
    mutationFn: updateMaintenanceServiceStoreIds,
  });
}
